<template>
    <div class="searchCommonBox">
        <input type="text" v-model="searchText" class="searchInput" @keyup.enter="searchBoard"/>
        <input type="button" value="검 색" @click="searchBoard" class="searchBtn searchBtnCmmn" />
        <input type="button" @click="resetSearchText" value="검색초기화" class="searchResetBtn searchBtnCmmn mobileReset" />
    </div>
</template>
<script>
export default {
    data(){
        return{
            searchText : this.$route.query.searchText
        }
    },
    methods:{
        resetSearchText(){
            this.searchText = "";
            let path = this.$store.state.board.url;
            if (this.$route.fullPath !== path){
                this.$router.push({ path: path});
            }

            this.searchBoard();
        },
        searchBoard(){
            let url = this.$store.state.board.url;
            let path = url
            if(this.searchText){
                path = `${url}?searchText=${this.searchText}`;
                if (this.$route.fullPath !== path){
                    this.$router.push({ path: url, query: { searchText : this.searchText }});
                }
            }
            else {
                this.$router.push({ path: url });
            }
            
            if(this.$parent.$refs.board.$refs.table1){
                this.$parent.$refs.board.$refs.table1.refresh();
            }
            if(this.$parent.$refs.board.$refs.table2){
                this.$parent.$refs.board.$refs.table2.refresh();
            }
        },
    }
}
</script>